import { useEffect, useState } from 'react';
import axios from 'axios';

import type { UserTitle } from '@/types/user-title';
import { config } from '@/config';

const useUserTitles = () => {
  const [userTitles, setUserTitles] = useState<UserTitle[] | null>(null);
  const [loadingUserTitles, setLoadingUserTitles] = useState<boolean>(true);
  const [userTitlesError, setUserTitlesError] = useState<string | null>(null);

  useEffect(() => {
    const getUserTitles = async () => {
      try {
        const { data } = await axios.get(`${config.site.api}/api/v1/titles`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });

        setUserTitles(data.data);
        setUserTitlesError(null);
      } catch (error) {
        console.error(error?.message);
        setUserTitlesError('Failed to retrieve user titles');
        setUserTitles([]);
      }

      setLoadingUserTitles(false);
    };

    getUserTitles();
  }, []);

  return { userTitles, loadingUserTitles, userTitlesError };
};

export default useUserTitles;
